import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import moment from 'moment';
import hash from 'object-hash';
import { FormattedMessage } from 'react-intl';
import FormattedCurrency from 'components/ui/FormattedCurrency';
import { Cell, TableRow, Table, TableHeader } from 'components/ui/StyledTable';
import { VoucherStatus } from 'constants/vouchers';

const DATE_DISPLAY_FORMAT = 'YYYY-MM-DD';
const DATE_TIME_DISPLAY_FORMAT = 'YYYY-MM-DD HH:mm';

const VouchersTable = ({ vouchers }) => (
  <Table data-cy="vouchers-table">
    <TableHeader columns={8}>
      <Cell span={1}>
        <FormattedMessage id="vouchers.voucherAlias" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="vouchers.voucherStatus" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="vouchers.originalBalance" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="vouchers.balance" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="vouchers.salesPeriodEnd" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="vouchers.voucherType" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="vouchers.createdBy" />
      </Cell>
      <Cell span={1}>
        <FormattedMessage id="vouchers.createdAt" />
      </Cell>
    </TableHeader>
    {vouchers.map((t) => (
      <TableRow columns={8} key={hash(t)} data-cy="voucher-content">
        <Cell alignItems="center" span={1} data-cy="cell">
          <Link to={`/vouchers/${t.alias}`}>{t.alias}</Link>
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          <FormattedMessage id={VoucherStatus[t.status]} />
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          <FormattedCurrency amount={t.value || 0} currency={t.currency} />
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          <FormattedCurrency amount={t.balance || 0} currency={t.currency} />
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          {moment(t.salesPeriodEnd).format(DATE_DISPLAY_FORMAT)}
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          {t.description}
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          {t.createdBy}
        </Cell>
        <Cell alignItems="center" span={1} data-cy="cell">
          {moment(t.createdAt).format(DATE_TIME_DISPLAY_FORMAT)}
        </Cell>
      </TableRow>
    ))}
  </Table>
);

VouchersTable.propTypes = {
  vouchers: PropTypes.arrayOf(PropTypes.object)
};

export default VouchersTable;
